module.exports = __webpack_public_path__ + "static/media/phone-min.58ec5896.png";